import React from 'react'
import {CURRENCY_HEADER, LAST_UPDATE_HEADER, NO_DATA_FOUND, PRICE_HEADER} from "../../../components/i18n/i18n";
import {Col, Row} from "reactstrap";

const Prices = ({prices}) => {
    return prices.length <= 0
        ? <center>{NO_DATA_FOUND}</center>
        : <>
            <Row>
                <Col  md={"2"}><h4>{CURRENCY_HEADER}</h4></Col>
                <Col  md={"1"}><h4>{PRICE_HEADER}</h4></Col>
                <Col  md={"2"}><h4>{LAST_UPDATE_HEADER}</h4></Col>
            </Row>
            {
                prices.map( (price, index) => <Row key={`price-${index}`}>
                    <Col  md={"2"}>{price?.currency}</Col>
                    <Col  md={"1"}>{`$${price?.normalAmount}`}</Col>
                    <Col  md={"2"}>{price?.lastUpdateTime}</Col>
                </Row>)
            }
        </>
}

export default Prices